import store from '../store';
import Fattureincloud from '../views/fattureincloud/Index.vue';
import FattureincloudOrder from '../views/fattureincloud/Order.vue';
import { checkauth } from '../Helper';

const FicDocument = () => import('../views/fattureincloud/Document.vue');

function auth(to, from, next) {
	checkauth().then(response => (response ? next() : next('/login')));
}

export default [
	{
		path: '/fattureincloud',
		name: 'fattureincloud',
		component: Fattureincloud,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
	// documenti di un ordine: pagine, non piu' finestre della lista
	{
		path: '/fattureincloud/:id([0-9a-fA-F]{24})/corrispettivo',
		name: 'fattureincloud-corrispettivo',
		component: FicDocument,
		props: { tipo: 'corrispettivo' },
		beforeEnter: auth,
	},
	{
		path: '/fattureincloud/:id([0-9a-fA-F]{24})/fattura',
		name: 'fattureincloud-fattura',
		component: FicDocument,
		props: { tipo: 'fattura' },
		beforeEnter: auth,
	},
	{
		path: '/fattureincloudorder',
		name: 'fattureincloudorder',
		component: FattureincloudOrder,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
];
